export default [
  {
    path: '/messageQuery/list',
    name: 'messageQuery',
    meta: {
      title: '留言查询'
    },
    component: () => import (/* webpackChunkName: "messageQueryt" */ '../views/messageQuery/list.vue')
  }, {
    path: '/messageQuery/details',
    name: 'messageQuery',
    meta: {
      title: '留言详情'
    },
    component: () => import (/* webpackChunkName: "messageQueryt" */ '../views/messageQuery/details.vue')
  }
]
